module.exports = __webpack_public_path__ + "img/us-map.a802f17d.svg";